<script setup lang="ts">
interface Props {
  modelValue: number[];
  list: {
    id: number;
    name: string;
  }[];
  required?: boolean;
}

interface Emits {
  (e: "update:modelValue", value: number[]): void;
}

const props = withDefaults(defineProps<Props>(), {
  required: false,
});
const emits = defineEmits<Emits>();

if (props.required) {
  useValidatable();
}

const localValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
});

const isError = ref(false);

function validate() {
  // 必須ではない|| 必須で値が一つ以上選択されている
  if (!props.required || (props.required && localValue.value.length > 0)) {
    isError.value = false;
    return true;
  }
  isError.value = true;
  return false;
}

watchDebounced(
  () => localValue.value,
  () => {
    // 値がないときは入力時のvalidateを行わない。submit時のvalidateは実行される
    if (localValue.value.length) {
      validate();
    }
  },
  { debounce: 500 },
);

defineExpose({
  validate,
});
</script>

<template>
  <ul class="flex flex-col gap-2 p-2" :class="{ 'bg-red-100': isError }">
    <li v-for="item in list" :key="item.id">
      <label class="cursor-pointer">
        <input
          :key="item.id"
          v-model="localValue"
          type="checkbox"
          :name="item.name"
          :value="item.id"
        />
        {{ item.name }}
      </label>
    </li>
  </ul>
</template>
